import type { Static } from 'runtypes';
import { Literal, Optional, Record, String, Union } from 'runtypes';
import { CoreEventRuntype } from './core';
import type { BaseEvent } from './base';
import { BaseEventRuntype } from './base';
import { ClickstreamEventEnum } from 'bc-model';

const ExceptionUnhandledBaseRuntype = BaseEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.EXCEPTION_UNHANDLED),
    message: String,
    name: String,
    source: Union(Literal('browser'), Literal('server')),
    stack: Optional(String),
    url: Optional(String),
    version: Literal(2),
  })
);

const ExceptionUnhandledBrowserRuntype = ExceptionUnhandledBaseRuntype.And(
  Record({
    source: Literal('browser'),
    url: String,
  })
);

const ExceptionUnhandledEventServerRuntype = ExceptionUnhandledBaseRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String.nullable(),
  })
);

type ExceptionUnhandledBrowserEvent = Static<typeof ExceptionUnhandledBrowserRuntype>;
type ExceptionUnhandledServerEvent = Static<typeof ExceptionUnhandledEventServerRuntype>;

const isExceptionUnhandledBrowserEvent = (
  obj: BaseEvent
): obj is ExceptionUnhandledBrowserEvent => {
  return obj.event === 'Exception Unhandled';
};

const isExceptionUnhandledServerEvent = (obj: BaseEvent): obj is ExceptionUnhandledServerEvent => {
  return obj.event === 'Exception Unhandled';
};

export {
  isExceptionUnhandledBrowserEvent,
  isExceptionUnhandledServerEvent,
  ExceptionUnhandledBrowserRuntype,
  ExceptionUnhandledEventServerRuntype,
  type ExceptionUnhandledBrowserEvent,
  type ExceptionUnhandledServerEvent,
};
